import React from 'react';

export function Suggestions() {
  return <div>Suggestions</div>;
}
